import { createRoot } from 'react-dom/client'
import { App } from './components/App'
import { CarabinerProduct } from './types'
import { normalizeProduct } from './utils'

const container = document.getElementById('feature-product-carabiner')

if (!container) {
  throw new Error('Container for Carabiner product not found')
}

const productJsonString = container.dataset.productJsonString as string
const linkedProductsJsonString = container.dataset.linkedProductsJsonString as string

const product = normalizeProduct(JSON.parse(productJsonString) as CarabinerProduct)
const linkedProducts = (JSON.parse(linkedProductsJsonString) as CarabinerProduct[]).map((item) => normalizeProduct(item))

createRoot(container).render(
  <App product={product} linkedProducts={linkedProducts} />
)